export const links = [
    { title: 'Home', url: '/' },
    { title: 'Request Order', url: '/Request-Order' },
    { title: 'Special Offers', url: '/Special/Offer' },
    { title: 'Branch Locations', url: '/BranchLocation' },
    { title: 'Review', url: '/Review' },
    { title: 'Gallery', url: '/Gallery' },
    { title: 'About Us', url: '/About' },
    { title: 'Contact Us', url: '/Contact' },
  ];